import React, { useRef } from "react";
import {
  Button,
  TextInput,
  TextInputProps,
  Tooltip,
  useMantineTheme,
} from "@mantine/core";
import { FilterRemove, SearchNormal1 } from "iconsax-react";

interface IProps extends TextInputProps {
  onClick?: () => void;
  placeholder?: string;
}

const Search = ({ onClick, placeholder, ...props }: IProps) => {
  const theme = useMantineTheme();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    if (props.value) {
      onClick?.();
    } else {
      inputRef.current?.focus();
    }
  };

  return (
    <TextInput
      ref={inputRef}
      h={56}
      w={"100%"}
      mt={0}
      placeholder={placeholder ? placeholder : "Pesquisar pelo serviço"}
      type="search"
      rightSection={
        <Button
          bg={"transparent"}
          p={0}
          sx={{
            ":hover": {
              backgroundColor: "transparent",
            },
          }}
          style={{
            border: "none",
            cursor: "pointer",
          }}
          type="button"
          onClick={handleButtonClick}
        >
          {props.value ? (
            <Tooltip label="Limpar Campo" withArrow>
              <FilterRemove size="24" color={theme.colors.basic[5]} />
            </Tooltip>
          ) : (
            <SearchNormal1 size="24" color={theme.colors.basic[5]} />
          )}
        </Button>
      }
      {...props}
    />
  );
};

export default Search;
